import {
    GroupInfo,
    IdsAdapterService,
    IdsGroup,
    InboxType,
    ProjectService,
    TrimDirective,
} from '@alpha-core/platform-ui';
import {
    ADMIN_INBOX_TYPES,
    ENQIORY_INBOX_TYPES,
    FetchAdminFilterById,
    INBOX_CONFIG,
    INBOX_LIST_TYPE,
    INBOX_NAME_LABEL,
    INBOX_TYPES,
    InboxAttributes,
    InboxName,
    InboxRelation,
    UserListRespone,
} from '@alpha-core/platform-ui/interfaces/admin-filter.interface';
import { Component, OnInit, inject } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { lastValueFrom } from 'rxjs';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { AdminFilterService } from '../../../services/admin-filter.service';
import { InboxService } from '../../../services/inbox.service';
import { PrimeNGModules } from '../../../shared/alpha-shared.module';
import { CheckboxListComponent } from '../../users/checkbox-list/checkbox-list.component';
import { EditCutomFilterComponent } from '../edit-custom-filter/edit-custom-filter.component';
import { atLeastOneRequired } from '../validators/at-least-one-field.validator';

export interface CatergoryItems {
    title: string;
    lang: string;
    icon: string;
    activeIcon: string;
    label: string;
    formName: string;
    info: {
        default: string;
        lang: string;
    };
}

export interface InboxTypeItem {
    label: string;
    value: string;
    filters: any[];
    disabled: boolean;
    path: InboxRelation;
    inboxName: InboxName;
}

export interface Group extends GroupInfo {
    checked?: boolean;
}
export interface User extends UserListRespone {
    checked?: boolean;
}
export interface SourceItem {
    label: string;
    value: string;
    filters: any[];
    disabled: boolean;
    inboxName: InboxName;
    path: InboxType;
}
@Component({
    selector: 'app-create-custom-list',
    standalone: true,
    templateUrl: './create-custom-list.component.html',
    styles: ``,
    imports: [
        ...PrimeNGModules,
        ReactiveFormsModule,
        TranslatePipe,
        EditCutomFilterComponent,
        CheckboxListComponent,
        TrimDirective,
    ],
})
export class CreateCustomListComponent implements OnInit {
    private message = inject(MessageService);
    private route = inject(ActivatedRoute);

    private formBuilder: FormBuilder = inject(FormBuilder);
    private adminFilterService: AdminFilterService = inject(AdminFilterService);
    private projectService: ProjectService = inject(ProjectService);
    private router: Router = inject(Router);
    private inboxService: InboxService = inject(InboxService);
    private idsAdapterService: IdsAdapterService = inject(IdsAdapterService);

    selectedFilter: FetchAdminFilterById | null = null;

    createCustomFilterForm: FormGroup<any> = new FormGroup(
        {
            name: new FormControl('', [Validators.required]),
            description: new FormControl('', [Validators.required]),
            inboxListType: new FormControl('', [Validators.required]),
            filters: new FormControl({}),
            additionalFilters: new FormControl({}),
            groups: this.formBuilder.array([]),
            users: this.formBuilder.array([]),
            filterId: new FormControl(undefined),
        },
        {
            validators: atLeastOneRequired(['filters', 'additionalFilters']),
        },
    );

    groups: IdsGroup[] = [];
    users: UserListRespone[] = [];

    fetchedGroups: IdsGroup[] = [];
    fetchedUsers: UserListRespone[] = [];

    currentPage = 0;
    allLoaded = false;
    loadMoreError = false;

    filterId: string | null = null;
    selectedInboxFilters: Array<Record<string, string>> = [];

    inboxTypes: {
        label: string;
        value: string;
        items: InboxTypeItem[];
    }[] = [];
    inboxTypesValueMap = new Map<string, InboxTypeItem>();

    updatefilter: boolean = false;

    filterMenu: CatergoryItems[] = [
        {
            title: 'Add Filters',
            lang: 'default-admin-filters-add',
            icon: 'filter-icon-nonactive.svg',
            activeIcon: 'filter-icon-filled.svg',
            label: 'filters',
            formName: 'filters',
            info: {
                default: 'Select one or more groups to grant access to these curated filters.',
                lang: 'default-admin-filters-add-info',
            },
        },
    ];

    assignmentsMenu: CatergoryItems[] = [
        {
            title: 'Select Groups',
            lang: 'default-admin-filters-selectGroupsToAdd',
            icon: 'group-user.svg',
            activeIcon: 'group-user-filled.svg',
            label: 'group_name',
            formName: 'groups',
            info: {
                default: 'Set up custom filters-select data fields, define criteria, name your filter, and click Save.',
                lang: 'default-admin-filters-selectGroupsToAdd-info',
            },
        },
        {
            title: 'Select Users',
            lang: 'default-admin-filters-selectUsersToAdd',
            icon: 'users-inactive.svg',
            activeIcon: 'users-active.svg',
            label: 'user_id',
            formName: 'users',
            info: {
                default: 'Select users (single or multiple) to assign access to these curated filters.',
                lang: 'default-admin-filters-selectUsersToAdd-info',
            },
        },
    ];
    activeMenuIndex = 0;
    activePageMenu: any = 0;
    categories: { categoryMenu: string; lang: string; items: CatergoryItems[] }[] = [
        {
            categoryMenu: 'Set filters',
            lang: 'default-admin-filters-setFilters',
            items: this.filterMenu,
        },
        {
            categoryMenu: 'Assignments',
            lang: 'default-admin-filters-assignments',
            items: this.assignmentsMenu,
        },
    ];
    sideBar: boolean = false;
    headers = [
        {
            title: 'default-admin-filters-add',
            defaultTitle: 'Add Filters',
            description: 'default-admin-filterAddsDescription',
            defaultDescription: 'Add some custom Filters',
        },
        {
            title: 'default-cm-selectGroupsToAdd',
            defaultTitle: 'Choose Groups',
            description: 'default-cm-selectGroupsToAddDescription',
            defaultDescription: 'Choose the groups you want to include.',
        },
        {
            title: 'default-cm-selectUsersToAdd',
            defaultTitle: 'Choose Users',
            description: 'default-cm-selectUsersToAddDescription',
            defaultDescription: 'Choose the users you want to include.',
        },
    ];

    selectTabMenu: {
        label: string;
        formName: string;
        filterData: Array<any>;
    } = {
        label: '',
        formName: '',
        filterData: [],
    };

    breadCrumbConfig: MenuItem[] = [];

    selectedFiltersType: 'filters' | 'additionalFilters' = 'filters';
    filterTypeOptions: { label: string; lang: string; value: string }[] = [
        { label: 'Default', lang: 'default-admin-filters-default', value: 'filters' },
        { label: 'Additional', lang: 'default-admin-filters-additional', value: 'additionalFilters' },
    ];

    searchKey: string = '';
    hideSpinner: boolean = true;

    ngOnInit(): void {
        this.breadCrumbConfig.push({
            label: 'default-admin-filters-all-list',
            routerLink: '/home/custom-list',
            queryParams: { projectId: this.projectService.fetchCurrentProject()?.projectId },
        });
        this.fetchInboxConfig().then((_) => {
            this.fetchFilter();
        });
    }

    async fetchInboxConfig() {
        const response: any = await this.inboxService.getAllInboxFilterConfig({
            attributes: [InboxAttributes.IS_FILTER_VISIBLE],
        });

        if (!response) {
            console.error('Failed to fetch the inbox configurations');
            return;
        }

        const formatItems = (parent: InboxName, source: Record<string, any>, inboxLists: INBOX_LIST_TYPE[]) => {
            const items: any = [];
            inboxLists.forEach((c) => {
                const key = c as INBOX_LIST_TYPE;
                const { label, path, lang } = INBOX_CONFIG[key];
                const entry = source?.[path];
                if (!entry) return;
                const item = {
                    label,
                    value: key,
                    path,
                    inboxName: parent,
                    filters: [],
                    lang,
                    disabled: !entry.isFilterVisible,
                };
                this.inboxTypesValueMap.set(key, item);
                items.push(item);
            });
            return items;
        };

        const inboxTypes: any[] = [];
        if (response[InboxName.INBOX]) {
            const key = INBOX_NAME_LABEL[InboxName.INBOX];
            const value = InboxName.INBOX;
            inboxTypes.push({
                label: key,
                lang: 'default-cm-inbox',
                value,
                items: formatItems(value, response[value], INBOX_TYPES),
                suffix: false,
            });
        }
        if (response[InboxName.ADMIN]) {
            const key = INBOX_NAME_LABEL[InboxName.ADMIN];
            const value = InboxName.ADMIN;
            inboxTypes.push({
                label: key,
                lang: 'default-cm-admin',
                value,
                items: formatItems(value, response[value], ADMIN_INBOX_TYPES),
                suffix: true,
            });
        }
        if (response[InboxName.ENQUIRY]) {
            const key = INBOX_NAME_LABEL[InboxName.ENQUIRY];
            const value = InboxName.ENQUIRY;
            inboxTypes.push({
                label: key,
                lang: 'default-cm-enquiry',
                value,
                items: formatItems(value, response[value], ENQIORY_INBOX_TYPES),
                suffix: true,
            });
        }

        this.inboxTypes = inboxTypes;
    }

    async fetchFilter() {
        this.filterId = this.route.snapshot.paramMap.get('filterId');

        if (!this.filterId) {
            this.adminFilterService.updateBreadcrumb([
                ...this.breadCrumbConfig,
                {
                    label: 'default-cm-add',
                },
            ]);
            return;
        }

        this.createCustomFilterForm.patchValue({
            filterId: this.filterId,
        });

        this.updatefilter = true;
        const response = await lastValueFrom(this.adminFilterService.getFilterById(this.filterId));
        this.selectedFilter = response;

        this.adminFilterService.updateBreadcrumb([
            ...this.breadCrumbConfig,
            {
                label: this.selectedFilter?.filterName,
            },
        ]);

        if (!response) return;
        // Search all inbox types for a match
        if (response.inboxListType) {
            await this.onChangeInboxType({ value: response.inboxListType } as DropdownChangeEvent);
        }

        this.createCustomFilterForm.patchValue({
            name: response.filterName,
            description: response.description,
            inboxListType: response.inboxListType,
            filters: response.filters,
            additionalFilters: response.additionalFilters,
        });

        // Groups patch
        const groupsArray = this.createCustomFilterForm.get('groups') as FormArray;
        groupsArray.clear();
        (response.groups ?? []).forEach((g: any) => groupsArray.push(this.formBuilder.control(g)));

        // Users patch
        const usersArray = this.createCustomFilterForm.get('users') as FormArray;
        usersArray.clear();
        (response.users ?? []).forEach((u: any) => usersArray.push(this.formBuilder.control(u)));
    }

    async setMenu(parentIndex: number, pageIndex: number, itemConfig: CatergoryItems) {
        this.sideBar = true;
        this.activePageMenu = {
            activeMenuCategory: parentIndex,
            activeCategoryItem: pageIndex,
        };
        this.activeMenuIndex = pageIndex + parentIndex;
        this.selectTabMenu.label = itemConfig.label || '';
        this.selectTabMenu.formName = itemConfig.formName || '';
        this.selectTabMenu.filterData = [];
        this.currentPage = 0;
        this.allLoaded = false;
        this.selectTabMenu.filterData = await this.fetchFilterData(itemConfig.label);
    }

    async fetchFilterData(label: string) {
        if (label == 'group_name') {
            return await this.makeGroupsList();
        } else if (label == 'user_id') {
            return await this.makeUsersList();
        }
        return [];
    }

    close() {
        this.sideBar = false;
    }

    onCancel() {
        const project = this.projectService.fetchCurrentProject();
        const queryParams: any = {
            projectId: project?.projectId,
        };
        this.router.navigate(['/home/custom-list'], { queryParams });
    }

    async onSubmit() {
        if (!this.createCustomFilterForm.valid) {
            return;
        }

        const payload = this.createCustomFilterForm.value;
        const response = this.filterId
            ? await lastValueFrom(this.adminFilterService.updateFilter(payload))
            : await lastValueFrom(this.adminFilterService.createFilter(payload));

        if (response) {
            this.message.add({
                severity: 'success',
                summary: 'Success!',
                detail: `Custom List ${this.filterId ? 'updated' : 'created'} successfully`,
            });
            this.onCancel();
        }
    }

    onSelect(event: { item: any; checked: boolean }) {
        const formArrayName = this.selectTabMenu.formName as 'groups' | 'users';
        const formArray = this.createCustomFilterForm.get(formArrayName) as FormArray;

        const isGroup = formArrayName === 'groups';
        const key = isGroup ? 'groupName' : 'userName';
        const itemKey = isGroup ? event.item.group_name : event.item.user_id;

        const index = formArray.controls.findIndex((ctrl) => ctrl.value[key] === itemKey);

        if (event.checked) {
            if (index === -1) {
                formArray.push(
                    this.formBuilder.control({
                        id: event.item.id,
                        [key]: itemKey,
                    }),
                );
            }
        } else if (index !== -1) {
            formArray.removeAt(index);
        }
    }

    onSelectAll(checked: boolean) {
        (this.selectTabMenu.filterData || []).forEach((item: any) => {
            item.checked = checked;
            this.onSelect({ item, checked });
        });
    }

    async onChangeInboxType(event: DropdownChangeEvent) {
        const inboxTypeValue = this.inboxTypesValueMap.get(event.value);
        if (!inboxTypeValue) return;
        const { inboxName, path: inboxType } = inboxTypeValue;

        const response: any = await this.inboxService.getAllInboxFilterConfig({
            inboxName,
            inboxType,
            attributes: [InboxAttributes.FILTERS],
        });
        if (!response) {
            return;
        }
        this.createCustomFilterForm.patchValue({
            filters: {},
        });
        this.selectedInboxFilters = response[inboxName][inboxType].filters || [];
    }

    onChangeFilters(event: Record<string, any>) {
        this.createCustomFilterForm.patchValue({
            [this.selectedFiltersType]: event,
        });
    }

    filter(searchValue: string) {
        this.currentPage = 0;
        this.allLoaded = false;
        this.searchKey = searchValue;
        const label = this.selectTabMenu.label;
        if (label === 'group_name') {
            this.makeGroupsList(searchValue);
        } else if (label === 'user_id') {
            this.makeUsersList(searchValue);
        }
    }

    async makeUsersList(searchKey: string = '') {
        const response = await this.idsAdapterService.fetchAllUsers(
            {
                pageSize: 10,
                pageNumber: this.currentPage,
                search: searchKey,
            },
            this.hideSpinner,
        );
        const newUsers = response.umas || [];
        const userSet = new Set((this.selectedFilter?.users ?? []).map((u: any) => u.userName));
        const mapped = newUsers.map((user) => ({
            ...user,
            checked: userSet.has(user.user_id),
        }));

        if (searchKey && this.currentPage === 0) {
            this.users = mapped;
        } else {
            this.users = [...this.users, ...mapped];
        }

        if (response.totalCount <= this.users.length) {
            this.allLoaded = true;
        }

        this.selectTabMenu.filterData = this.users;
        return this.users;
    }

    async makeGroupsList(searchKey: string = '') {
        const response = await this.idsAdapterService.fetchAllGroups(
            {
                pageSize: 10,
                pageNumber: this.currentPage,
                search: searchKey,
            },
            this.hideSpinner,
        );
        const newGroups = response.groups || [];
        const groupSet = new Set((this.selectedFilter?.groups ?? []).map((g: any) => g.groupName));
        const mapped = newGroups.map((group) => ({
            ...group,
            checked: groupSet.has(group.group_name),
        }));

        if (searchKey || this.currentPage === 0) {
            this.groups = mapped;
        } else {
            this.groups = [...this.groups, ...mapped];
        }

        if (response.totalCount <= this.groups.length) {
            this.allLoaded = true;
        }

        this.selectTabMenu.filterData = this.groups;
        return this.groups;
    }

    clearAll() {
        this.createCustomFilterForm.reset();
        this.createCustomFilterForm.patchValue({
            groups: [],
            users: [],
        });
        this.selectedInboxFilters = [];
        this.sideBar = false;
        this.selectTabMenu = {
            label: '',
            formName: '',
            filterData: [],
        };
        this.users = [];
        this.groups = [];
        this.activeMenuIndex = 0;
        this.activePageMenu = 0;
    }

    async onLoadMore() {
        this.currentPage++;
        this.loadMoreError = false;
        const label = this.selectTabMenu.label;
        try {
            if (label === 'group_name') {
                await this.makeGroupsList(this.searchKey);
            } else if (label === 'user_id') {
                await this.makeUsersList(this.searchKey);
            }
        } catch {
            this.currentPage--;
            this.loadMoreError = true;
        }
    }
}
